<template>
  <el-config-provider :locale="locale">
    <router-view />
  </el-config-provider>
</template>

<script>
// ElementPlus 使用的语言国际化语言
import zh from "element-plus/dist/locale/zh-cn"
import en from "element-plus/dist/locale/en"
import watermark from "@/components/watermark/watermark";
import {loginUserStore} from "@/stores/loginUserStore";
import {getCurrentYYMMDD} from "@/utils/dateUtils"
export default {
  name: 'App',
  components: {

  },
  setup() {
    return {
      locale : localStorage.getItem('lang') === 'en' ? en : zh,
      watermarkText : loginUserStore().sessionInfo.realname
    }
  },
  mounted() {
    if (self != top) {
      //alert('在iframe中');
    }else{
      watermark.set(getCurrentYYMMDD()+this.watermarkText === undefined ? "" : this.watermarkText);
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
body{
  margin: 0;
  width: 100%;
  height: 100%;
}
html{
  margin: 0;
  width: 100%;
  height: 100%;
}
*{
  box-sizing: border-box;
}

/*ElLoading 全局样式*/
.my-loading .el-loading-spinner i {
  color: #409eff;
}

.my-loading .el-loading-spinner .el-loading-text {
  color: #409eff;
}

.el-loading-spinner .circular {
  display: none !important;
}

.my-loading .el-loading-spinner {
  background: url('./assets/loading/loading.gif') no-repeat;
  background-size: 200px 200px;
  width: 100%;
  height: 100%;
  left: calc(50% - 100px);
  top: calc(50% - 100px) !important;
  text-align: center;
}


/*避免点击出现蓝色的框*/
:focus-visible {
  outline: none;
}
</style>
